(() => {
	angular.module('main').directive('snTimepicker', snTimepicker);

	snTimepicker.$inject = [
		'randomStringGenerator',
		'$location',
		'settingsService',
		'timeConverter'
	];

	function snTimepicker(
		randomStringGenerator,
		$location,
		settingsService,
		timeConverter
	) {
		let template = '';

		template += '<div class="bootstrap-timepicker timepicker">';

		template +=
			'<input id="{{timepickerId}}" name="{{timepickerId}}" ng-required="!checked" ng-disabled="checked"';
		template += ' type="text" class="form-control"';
		template += ' placeholder="HH:mm"';
		template += ' ng-focus="fillEmptyVal()"';
		template += ' ng-model="snDrModel">';

		template +=
			'<span class="input-group-addon"><i class="fa fa-clock-o"></i></span>';
		template += '</div>';

		return {
			restrict: 'AE',
			scope: {
				snDrModel: '=',
				snRequired: '=',
				checked: '=snDrChecked',
				domTime: '@'
			},

			template,
			replace: true,

			link(scope, elem) {
				scope.timepickerId = `timepicker-sm-${randomStringGenerator.getMixedString(
					9
				)}`;

				let timeFormatIs12HorsFormat;
				settingsService.timeFormatSettings.subscribe(data => {
					if (data.timeFormat !== null) {
						timeFormatIs12HorsFormat = data.timeFormat === 'T_12';

						jQuery(elem[0].firstChild).timepicker({
							defaultTime: scope.snDrModel || false,
							minuteStep: 1,
							showInputs: true,
							showMeridian: timeFormatIs12HorsFormat,
							maxHours: 24,
							appendWidgetTo: elem,
							icons: {
								up: 'fa fa-chevron-up',
								down: 'fa fa-chevron-down'
							}
						});
					}
				});

				let dtStr = scope.snDrModel;
				const isStartDate =
					typeof dtStr !== 'undefined' && dtStr !== null && dtStr.length > 10;

				if (isStartDate) {
					dtStr = dtStr.substring(0, 19).replace(/T/g, ' ');
					dtStr = dtStr.replace(/\-/g, '/');

					let _dateUTC = new Date(dtStr);

					const _yy = _dateUTC.getFullYear(),
						_MM = _dateUTC.getMonth(),
						_dd = _dateUTC.getDate(),
						_hh = _dateUTC.getHours(),
						_mm = _dateUTC.getMinutes(),
						_ss = _dateUTC.getSeconds();

					_dateUTC = Date.UTC(_yy, _MM, _dd, _hh, _mm, _ss);

					const dt = new Date(_dateUTC);
					let h = dt.getHours(),
						m = dt.getMinutes(),
						_time;

					if (m.toString().length === 1) {
						m = `0${m}`;
					}

					_time = h > 12 ? `${h - 12}:${m} PM` : `${h}:${m} AM`;

					scope.snDrModel = _time;
					console.log('time', _time);
				}

				scope.$watch('snDrModel', newValue => {
					const jobModal = document.getElementById('newJob');
					const path = $location.path();
					const jobViewPage = path.includes('jobs/view');

					let jobModalShow;

					if (jobModal) {
						jobModalShow = jobModal.classList.contains('in');
					}
					if (scope.domTime && newValue && !jobModalShow && jobViewPage) {
						const timeInDom = jQuery(`#${scope.domTime}`).text();
						const timeInInput = jQuery(`#${scope.timepickerId}`).val();

						if (timeInInput != timeInDom) {
							jQuery(`#${scope.timepickerId}`).timepicker('setTime', timeInDom);
						}
					}
				});

				jQuery(elem[0])
					.on('mousedown', e => {
						jQuery(`#${scope.timepickerId}`).timepicker(
							'setTime',
							scope.snDrModel
						);
						let timepicker;
						timepicker = jQuery(`#${scope.timepickerId}`);
						if (
							!timeFormatIs12HorsFormat &&
							(scope.snDrModel.toUpperCase().includes('PM') ||
								scope.snDrModel.toUpperCase().includes('AM'))
						) {
							scope.snDrModel = timeConverter.convert24to12(scope.snDrModel);
						}
						if (
							!scope.snDrModel &&
							timepicker[0].attributes.disabled === undefined
						) {
							scope.snDrModel = '12:00 PM';
							scope.snDrModel = timeConverter.convert24to12(scope.snDrModel);
							timepicker.timepicker('setTime', '12:00 PM');
							timepicker.timepicker('showWidget');
							e.preventDefault();
						}
					})
					.on('show.timepicker', () => {
						if (!scope.snDrModel) {
							jQuery(`#${scope.timepickerId}`).timepicker(
								'setTime',
								'12:00 PM'
							);
						}
					})
					.on('click', () => {
						jQuery(`#${scope.timepickerId}`).timepicker('showWidget');
					});
			}
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/snTimepicker.js